module.exports = __webpack_public_path__ + "img/nolan-organization.1e14dc11.svg";